import React from 'react'

export default function({ text, size='md', useRegularFont=false }) {
  const sizeClass = `components--pill--${size}`
  const fontClass = useRegularFont ? `pill--regular` : '';
  return (
    <div className={`components--pill pill--label ${sizeClass} ${fontClass}`}>
      {text}
    </div>
  )
}
